import type {
  KinerjaHarianLogState,
  KinerjaHarianBadgeConfig,
  KinerjaHarianBadgeTone,
} from 'types/kinerja-harian'

export const PAGE_SIZE = 10

// Minimum sentToBknCount value that indicates a log has been sent to BKN.
// Once a log reaches this count, editing and deleting are disabled.
export const MIN_SENT_TO_BKN_COUNT = 1
export const ALL_MONTH_OPTION = 'all'
export const WIB_SUFFIX = 'WIB'

export const MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
] as const

export const WEEKDAY_LABELS = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']

export type CalendarStatus = 'EMPTY' | 'SUBMITTED' | 'SUCCESS' | 'FAILED'

export const CALENDAR_STATUS_CONFIG: Record<
  CalendarStatus,
  {
    cellClassName: string
    dotClassName?: string
    label: string
  }
> = {
  EMPTY: {
    cellClassName: 'bg-gray-5 text-gray-90',
    label: 'Belum ada catatan',
  },
  SUBMITTED: {
    cellClassName: 'bg-[#FFF8DD] text-[#C97500]',
    dotClassName: 'bg-[#D98C00]',
    label: 'Belum Dikirim ke E-Kinerja',
  },
  SUCCESS: {
    cellClassName: 'bg-[#E8FAF0] text-[#1F9254]',
    dotClassName: 'bg-[#1F9254]',
    label: 'Sudah Dikirim ke E-Kinerja',
  },
  FAILED: {
    cellClassName: 'bg-[#FFF8DD] text-[#C97500]',
    dotClassName: 'bg-[#D98C00]',
    label: 'Belum Dikirim ke E-Kinerja',
  },
}

export const CALENDAR_STATUS_BY_STATE: Record<
  KinerjaHarianLogState,
  CalendarStatus
> = {
  SENT_TO_BKN_SUCCESS: 'SUCCESS',
  SENT_TO_BKN_FAILED: 'FAILED',
  SENT_TO_BKN: 'SUCCESS',
  SUBMITTED: 'SUBMITTED',
}

export const BADGE_CONFIG_BY_STATE: Record<
  KinerjaHarianLogState,
  KinerjaHarianBadgeConfig
> = {
  SENT_TO_BKN_SUCCESS: {
    label: 'Sudah Dikirim ke E-Kinerja',
    tone: 'success' as KinerjaHarianBadgeTone,
  },
  SENT_TO_BKN_FAILED: {
    label: 'Belum Dikirim ke E-Kinerja',
    tone: 'warning' as KinerjaHarianBadgeTone,
  },
  SUBMITTED: {
    label: 'Belum Dikirim ke E-Kinerja',
    tone: 'warning' as KinerjaHarianBadgeTone,
  },
  SENT_TO_BKN: {
    label: 'Sedang Dikirim ke E-Kinerja',
    tone: 'informational' as KinerjaHarianBadgeTone,
  },
} as const

export const ABSENT_BADGE_CONFIG: KinerjaHarianBadgeConfig = {
  label: 'Tidak Hadir',
  tone: 'failed' as KinerjaHarianBadgeTone,
} as const

export const ABSENT_NOTE_MESSAGE =
  'Jenis Kinerja tidak perlu diisi karena Anda memilih Tidak Hadir pada tanggal yang dipilih.'

export const CONTENT_FORM_DESCRIPTIONS: Record<'GURU' | 'KS' | 'GPK', string> =
  {
    GURU: `Sesuai dengan Tugas Pokok 5M Guru dan Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Kepala Sekolah.`,
    KS: `Sesuai dengan beban kerja dan tugas Kepala Sekolah, serta Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Tim Kinerja atau Pejabat Penilai Kinerja.`,
    GPK: `Sesuai dengan Tugas Guru Pendidikan Khusus (GPK) dan Pengembangan Kompetensi. Silakan sesuaikan juga dengan kalender akademik daerah Anda. Tidak perlu unggah Bukti Dukung di dalam sistem, cukup tunjukkan Bukti Dukung ke Tim Kinerja dan Pejabat Penilai Kinerja.`,
  }
